import type { ReactNode } from "react";
import { useQuery } from "convex/react";
import { Navigate } from "react-router-dom";
import { api as convexApi } from "../../convex/_generated/api";

export interface LiveSessionRedirectProps {
  buildPath: (joinCode: string) => string;
  loading: ReactNode;
  noSession: ReactNode;
}

export function LiveSessionRedirect({ buildPath, loading, noSession }: LiveSessionRedirectProps) {
  const target = useQuery(convexApi.audience.getLiveJoinRouteTarget, {});

  if (target === undefined) return loading;
  if (target === null) return noSession;

  return <Navigate to={buildPath(target.joinCode)} replace />;
}
